define('lq/runtimeBusyIndicator',[
    'jquery',
    'drops/modals',
    'jquery.blockUI'
], function ($, modals) {
    'use strict';

    function RuntimeBusyIndicator($element) {
        this.showCount = 0;
        this.opacity = 0;

        this.$element = $element;

        $.blockUI.defaults.overlayCSS = {
            backgroundColor: '#FFF',
            opacity: 0.7,
            cursor: 'wait'
        };
        $.blockUI.defaults.fadeOut = 150;
        $.blockUI.defaults.fadeIn = 750;

        var imageHTML;
        if (window.document.documentMode) {
            imageHTML = '<img width="32" height="32 alt="loading" src="' + require.toUrl("../Lq/loading.gif") + '" />';
        } else {
            imageHTML = '<img width="64" height="64" alt="loading" src="' + require.toUrl("../Lq/loading_new.svg") + '" />';
        }
        this.$description = $('<div />');
        this.$indicator = $('<div />')
            .append($(imageHTML))
            .append(this.$description);

        this.$container = $('<div />')
            .append(this.$indicator)
    };

    RuntimeBusyIndicator.prototype.setOpacity = function (opacity) {
        this.opacity = opacity;
    };

    RuntimeBusyIndicator.prototype.show = function () {
        var self = this;

        self.showCount++;
        if (self.showCount === 1) {
            self._show(1000);
        }
    };

    RuntimeBusyIndicator.prototype.hide = function () {
        var self = this;
        self.showCount--;
        if (self.showCount < 1) {
            self.showCount = 0;
            this.$element.unblock();
            this.$description.text('');
            if (self.timeout) {
                clearTimeout(self.timeout);
                self.timeout = undefined;
            }
        }
    };

    RuntimeBusyIndicator.prototype.showText = function (text) {
        this.showHtml('<p>' + text + '</p>');
    };

    RuntimeBusyIndicator.prototype.showHtml = function (html) {
        this.$description.html(html);
    };

    RuntimeBusyIndicator.prototype.showElement = function ($element) {
        this.$indicator.detach();
        $element.appendTo(this.$container);
    };

    RuntimeBusyIndicator.prototype.removeElement = function () {
        this.$container.empty();
        this.$indicator.appendTo(this.$container);
    };

    RuntimeBusyIndicator.prototype.forceHide = function () {
        var self = this;
        var original = Number(self.showCount);
        self.showCount = 0;
        self.hide();
        return original;
    };

    RuntimeBusyIndicator.prototype.showWithCount = function (count) {
        var self = this;
        self.showCount = count;
        self._show(0);
    };

    RuntimeBusyIndicator.prototype._show = function (timeInMilliSec) {
        var overlayCss = {
            backgroundColor: '#000',
            opacity: this.opacity,
            cursor: 'default'
        };

        var zIndex = modals.getNextZIndex()
        
        this.$element.block({
            baseZ: zIndex,
            showOverlay: true,
            message: '',
            overlayCSS: overlayCss
        });

        this.opacity = 0; //reset opacity

        var self = this;
        this.timeout = setTimeout(function () {
            if (self.showCount > 0) {
                self.$element.block({
                    baseZ: zIndex,
                    showOverlay: true,
                    overlayCSS: overlayCss,
                    css: {
                        padding: 0,
                        margin: 0,
                        width: '30%',
                        top: '40%',
                        left: '35%',
                        textAlign: 'center',
                        color: '#000',
                        border: '0',
                        cursor: 'default'
                    },
                    message: self.$container
                });
            }
        }, timeInMilliSec);
    };

    return RuntimeBusyIndicator;
});

